export default __webpack_public_path__ + "static/borderMb2-4f686b9b1d7edde8c8876d5b84b9c8be.png";